/**
 * Layout pour les pages utilisateur (dashboard + settings)
 * Header avec UserMenu dropdown, contenu principal via Outlet
 */

import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth, UserMenu, type MenuItem } from '@features/auth';
import { APP_NAME } from '../../shared/utils/appConfig';

export function UserLayout() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/auth/login');
  };

  const adminSlugs = ['super-admin', 'admin-organisation', 'admin-national', 'admin-diocesain'];
  const isAdmin = user?.role && adminSlugs.includes(user.role);

  const menuItems: MenuItem[] = [
    { label: 'Dashboard', icon: '🏠', href: '/dashboard' },
    ...(isAdmin ? [{ label: 'Administration', icon: '⚙️', href: '/admin', separator: true }] : []),
    { label: 'Mon compte', icon: '👤', href: '/dashboard/account' },
    { label: 'Sécurité & 2FA', icon: '🔒', href: '/dashboard/2fa' },
    { label: 'Mot de passe', icon: '🔑', href: '/dashboard/password' },
    { label: 'Sessions actives', icon: '📱', href: '/dashboard/sessions' },
    { label: 'Paramètres de sécurité', icon: '🛡️', href: '/dashboard/security' },
    { label: 'Historique', icon: '📊', href: '/dashboard/history', separator: true },
    { label: 'Déconnexion', icon: '🚪', onClick: handleLogout, variant: 'danger' as const },
  ];

  return (
    <div className="min-h-screen bg-surface-raised">
      {/* Header avec menu utilisateur */}
      <header className="bg-surface shadow-sm border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo / Titre */}
            <div className="flex items-center">
              <button
                onClick={() => navigate('/dashboard')}
                className="text-2xl font-bold text-content hover:text-primary transition-colors"
              >
                {APP_NAME}
              </button>
            </div>

            {/* Menu utilisateur */}
            {user && (
              <UserMenu
                userName={`${user.prenom} ${user.nom}`}
                userEmail={user.email}
                menuItems={menuItems}
                onNavigate={(href) => navigate(href)}
              />
            )}
          </div>
        </div>
      </header>

      {/* Contenu principal */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}

export default UserLayout;
